module.exports = __webpack_public_path__ + "static/img/Slider_1_mobile.28305a3c.jpg";